import { render, staticRenderFns } from "./CardCountSend.vue?vue&type=template&id=772c96ca&"
import script from "./CardCountSend.vue?vue&type=script&lang=js&"
export * from "./CardCountSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports